import { FlightItem } from "@/typings";

export const initialSort = (list: FlightItem[]): FlightItem[] => {
  return list.sort((a: FlightItem, b: FlightItem): number => {
    if (a.airline_code === "LH") {
      return -1;
    }

    if (b.airline_code === "LH") {
      return 1;
    }

    if (a.airline_code === "NH") {
      return -1;
    }

    if (b.airline_code === "NH") {
      return 1;
    }

    return -1;
  });
};
